import type { DiscoveredRouteModule } from '@/router/generator/types';

const ForbiddenView = () => import('@/views/error-pages/ForbiddenView.vue');
export const NAME_FORBIDDEN = 'Forbidden';
export const PATH_FORBIDDEN = '/forbidden';

export const route: DiscoveredRouteModule = {
  id: 'root.error.forbidden',
  scope: 'root',
  name: NAME_FORBIDDEN,
  path: PATH_FORBIDDEN,
  component: ForbiddenView,
  meta: { isErrorPage: true, requiresAuth: false, skipProjectCheck: true, skipPermissionCheck: true },
};


